import _ from 'lodash'
import MODAL_CONFIG from './config'

class ModalClass {
    constructor() {
        this.DOM = {
            root: document.documentElement,
            modals: MODAL_CONFIG.modals,
            closer: MODAL_CONFIG.closer,
            triggers: MODAL_CONFIG.triggers,
            modal: null
        }

        this.id = String
        this.state = false
        this.DOM.modals ? this.init() : null
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.triggers.forEach( ( trigger ) => { trigger.addEventListener( 'click', this._state.bind( this ) ) })
        this.DOM.closer.addEventListener( 'click', this._state.bind( this ) )
    }

    _state() {
        event.preventDefault()
        this.state = !this.state
        this.state ? this._open() : this._close()
        console.log( this.state )
    }

    _open() {
        this.id = event.currentTarget.getAttribute( 'data-modal' )
        this.DOM.modal = _.select( `.c-modal[data-modal="${this.id}"]` )

        _.addClass( this.DOM.modals, 'is--active' )
        _.addClass( this.DOM.modal, 'is--active' )
        _.addClass( this.DOM.root, 'is--blocked' )
    }

    _close() {
        _.removeClass( this.DOM.modals, 'is--active' )
        _.removeClass( this.DOM.modal, 'is--active' )
        _.removeClass( this.DOM.root, 'is--blocked' )

        this.id = String
        this.DOM.modal = null
    }

}

const MODAL = new ModalClass()
export default MODAL